"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEIndustries = void 0;

require("core-js/modules/web.dom-collections.iterator.js");

var _react = _interopRequireWildcard(require("react"));

var _core = require("@material-ui/core");

var _FAEIndustry = require("../FAEIndustry/FAEIndustry");

var _FAEContainer = require("../FAEContainer/FAEContainer");

var _FAELoading = require("../FAELoading/FAELoading");

require("./FAEIndustries.scss");

const _excluded = ["industries", "className", "justify", "align", "expandIcon", "collapseIcon", "loading", "loaderProps"],
      _excluded2 = ["src", "alt", "label"],
      _excluded3 = ["src", "alt", "label"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEIndustries = _ref => {
  let {
    industries,
    className = "",
    justify,
    align,
    expandIcon,
    collapseIcon,
    loading,
    loaderProps
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  const [isVisible, setIsVisible] = (0, _react.useState)(false);
  const filteredIndustries = window.screen.width > 799 ? industries.filter((industry, index) => index < 12) : industries.filter((industry, index) => index < 10);
  const remainingIndustries = window.screen.width > 799 ? industries.filter((industry, index) => index >= 12) : industries.filter((industry, index) => index >= 10);

  const toggleIndustries = () => {
    setIsVisible(!isVisible);
  };

  return /*#__PURE__*/_react.default.createElement(_FAEContainer.FAEContainer, {
    justify: justify,
    align: align
  }, loading ? /*#__PURE__*/_react.default.createElement(_FAELoading.FAELoading, loaderProps) : /*#__PURE__*/_react.default.createElement("div", _extends({
    className: "fae--industries-main-container ".concat(className)
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--industries-container"
  }, filteredIndustries.map((industry, index) => {
    const {
      src,
      alt,
      label
    } = industry,
          rest = _objectWithoutProperties(industry, _excluded2);

    return /*#__PURE__*/_react.default.createElement(_FAEIndustry.FAEIndustry, _extends({
      key: index,
      src: src,
      alt: alt,
      label: label
    }, rest));
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--remaining-industries-container"
  }, /*#__PURE__*/_react.default.createElement(_core.Collapse, {
    timeout: 1000,
    in: isVisible
  }, remainingIndustries.map((industry, index) => {
    const {
      src,
      alt,
      label
    } = industry,
          rest = _objectWithoutProperties(industry, _excluded3);

    return /*#__PURE__*/_react.default.createElement(_FAEIndustry.FAEIndustry, _extends({
      key: index,
      src: src,
      alt: alt,
      label: label
    }, rest));
  })), window.screen.width > 799 && industries.length > 12 ? isVisible ? /*#__PURE__*/_react.default.createElement("img", {
    src: collapseIcon,
    alt: "Up Arrow",
    className: "fae--up-arrow",
    onClick: toggleIndustries
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: expandIcon,
    alt: "Down Arrow",
    className: "fae--down-arrow",
    onClick: toggleIndustries
  }) : "", window.screen.width < 799 && industries.length > 10 ? isVisible ? /*#__PURE__*/_react.default.createElement("img", {
    src: collapseIcon,
    alt: "Up Arrow",
    className: "fae--up-arrow",
    onClick: toggleIndustries
  }) : /*#__PURE__*/_react.default.createElement("img", {
    src: expandIcon,
    alt: "Down Arrow",
    className: "fae--down-arrow",
    onClick: toggleIndustries
  }) : "")));
};

exports.FAEIndustries = FAEIndustries;